import { YouTubeFacade } from "@/components/YouTubeFacade";

/**
 * PrismVideosSection
 *
 * Renders the Prism YouTube explainer videos in a responsive 2-column grid
 * as click-to-load facades (thumbnail + play button; nocookie iframe injected
 * on click) for mobile PageSpeed.
 */
const PRISM_VIDEOS = [
  { id: "OLMPaAsWocA", title: "Prism for PTSD — How It Works" },
  { id: "zNPtoMKS2j4", title: "Prism — What to Expect" },
  { id: "FPKIzH0vWWE", title: "Prism — Clinical Research Overview" },
  { id: "mCOHM-B7MpY", title: "Prism — Patient Experience" },
];

export default function PrismVideosSection() {
  return (
    <section
      className="relative bg-light-blue/40 py-16 lg:py-24"
      aria-labelledby="prism-videos-heading"
    >
      <div className="container-px mx-auto max-w-5xl">
        <div className="mb-10 text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-accent">
            Watch &amp; Learn
          </span>
          <h2
            id="prism-videos-heading"
            className="mt-3 font-headings text-2xl font-bold text-primary sm:text-3xl lg:text-[2.5rem]"
          >
            See Prism in Action
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">
            Learn how Prism works, what a session feels like, and what the
            research shows — directly from the team behind the treatment.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {PRISM_VIDEOS.map((video) => (
            <div
              key={video.id}
              className="overflow-hidden rounded-2xl border border-border bg-card shadow-soft"
            >
              <div className="p-3">
                <YouTubeFacade id={video.id} title={video.title} />
              </div>
              <p className="px-4 py-3 text-sm font-medium text-muted-foreground">
                {video.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
